var map = {
	"./cosi-fan-tutte.jpg": 138,
	"./die-walkure.jpg": 767,
	"./die-zauberflote.jpg": 780,
	"./don-giovanni.jpg": 341,
	"./giulio-cesare.jpg": 418,
	"./gotterdammerung.jpg": 230,
	"./il-barbiere-di-siviglia.jpg": 634,
	"./l-elisir-d-amore.png": 498,
	"./la-boheme.jpg": 811,
	"./le-nozze-di-figaro.jpg": 558,
	"./lohengrin.jpg": 151,
	"./madame-butterfly.jpg": 861,
	"./manon-lescaut.jpg": 781,
	"./nabucco.jpg": 756,
	"./parsifal.jpg": 78,
	"./rienze.jpg": 323,
	"./rigoletto.jpg": 516,
	"./tannhauser.jpg": 947,
	"./tosca.jpg": 629,
	"./turandot.jpg": 108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 231;